module.exports = __webpack_public_path__ + "img/logo-chaleur-100-fr.c1bcc3e9.svg";